import script from "./CancelationSub.vue?vue&type=script&setup=true&lang=js"
export * from "./CancelationSub.vue?vue&type=script&setup=true&lang=js"

import "./CancelationSub.vue?vue&type=style&index=0&id=726aac20&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-726aac20"]])

export default __exports__